import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ADMIN_BASE } from '../../lib/api';
import { formatApiError } from '../../lib/api';

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={ADMIN_BASE} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      await login(email.trim(), pwd);
      nav(ADMIN_BASE);
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card" data-testid="admin-login-card">
        <div className="admin-login-brand">
          <span className="logo-mark"><span>N</span></span>
          <div>
            <strong>Nathanael Appliances Corp</strong>
            <span>Admin Console</span>
          </div>
        </div>

        <h1>Sign in</h1>
        <p className="muted">Manage products, photos, and pricing.</p>

        <form onSubmit={onSubmit} className="admin-form">
          <label>
            <span>Email</span>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} autoComplete="username" data-testid="admin-email-input" />
          </label>
          <label>
            <span>Password</span>
            <input type="password" required value={pwd} onChange={e => setPwd(e.target.value)} autoComplete="current-password" data-testid="admin-password-input" />
          </label>

          {err && <div className="form-error" data-testid="admin-login-error">{err}</div>}

          <button type="submit" className="btn btn-primary btn-lg" disabled={busy} data-testid="admin-login-submit">
            <i className={busy ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-arrow-right-to-bracket'}></i>
            <span>{busy ? 'Signing in…' : 'Sign in'}</span>
          </button>
        </form>
      </div>
    </div>
  );
}
